import {
  ParkerRegistrationDTO,
  ParkingSessionDTO,
  ParkerRegistrationType,
  ParkerRegistrationOffense,
  ZoneDTO,
  ParkerRegistrationClient,
  ParkingSubscriptionLimitedDTO,
  ParkingSubscriptionType} from './../../../../base/models/models.swagger.generated';
import { Component, Input, OnInit } from '@angular/core';
import { StringHelper } from 'src/app/base/shared/string-helper';
import { ParkerRegistrationDetailsHelper } from '../parker-registration-details.helper';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ParkerRegistrationDetailOffenseComponent } from '../parker-registration-detail-offense/parker-registration-detail-offense.component';
import { TabModule } from '@syncfusion/ej2-angular-navigations';
import { NgIf, NgFor } from '@angular/common';
import { ParkerRegistrationDetailParkerDetailsComponent } from '../parker-registration-detail-parker-details/parker-registration-detail-parker-details.component';

@Component({
    selector: 'app-parker-registration-evaluated-detail',
    templateUrl: './parker-registration-evaluated-detail.component.html',
    styleUrls: ['./parker-registration-evaluated-detail.component.scss'],
    standalone: true,
    imports: [ParkerRegistrationDetailParkerDetailsComponent, NgIf, TabModule, NgFor, ParkerRegistrationDetailOffenseComponent, TranslateModule]
})
export class ParkerRegistrationEvaluatedDetailComponent implements OnInit {
  @Input()
  public zones: ZoneDTO[];

  @Input()
  public set parkingSession(value: ParkingSessionDTO) {
    this._parkingSession = value;
    if (!value?.parkerRegistrations?.length) {
      this.entry = null;
      this.exit = null;
    } else {
      this._parkingSession.parkerRegistrations?.sort((a, b) => a.registrationDateTime.valueOf() - b.registrationDateTime.valueOf());
      this.entry = this._parkingSession.parkerRegistrations[0];
      if (this._parkingSession.isClosed) {
        this.exit = this._parkingSession.parkerRegistrations[this._parkingSession.parkerRegistrations.length - 1];
      }
      // this.offenses = this._parkingSession.parkerRegistrations.filter((r: ParkerRegistrationDTO) => r.offense !== ParkerRegistrationOffense.NoOffense);
    }
  }

  public entry: ParkerRegistrationDTO;
  public exit: ParkerRegistrationDTO;
  public offenses: ParkerRegistrationDTO[] = [];
  private _parkingSession: ParkingSessionDTO;

  constructor(private translate: TranslateService,
    private parkerRegistrationClient: ParkerRegistrationClient) {
  }

  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  public get parkingSession(): ParkingSessionDTO {
    return this._parkingSession;
  }

  public ngOnInit(): void {
    this._parkingSession.parkerRegistrations.forEach(registration => {
      this.parkerRegistrationClient.getExtendedRegistration(registration.id)
      .subscribe(newRegistration => {
        registration = newRegistration;
        if(newRegistration.offense !== ParkerRegistrationOffense.NoOffense || newRegistration.penaltyIssued){
          this.offenses.push(newRegistration);
        }
      });
    });
    this.offenses.sort((a, b) => a.registrationDateTime.valueOf() - b.registrationDateTime.valueOf());
    const zone = this.zones.find(z => z.id === this._parkingSession.registeredZoneId);
  }

  public getParkingDuration(): string {
    if (this.parkingSession.parkingDuration) {
      return StringHelper.transformToTimeRepresentation(this.parkingSession.parkingDuration);
    }
    return '00:00';
  }

  public getRegistrationType(registration: ParkerRegistrationDTO): string {
    if (!registration) {
      return null;
    }
    return 'i18n.domain.parker-registration.ParkerRegistrationType.' + ParkerRegistrationType[registration.type];
  }

  public getRegisteredByText(registration: ParkerRegistrationDTO): string {
    return ParkerRegistrationDetailsHelper.getRegisteredByText(registration, this.translate);
  }

  public getSubscriptionType(subscription: ParkingSubscriptionLimitedDTO): string {
    if (!subscription) {
      return null;
    }
    return 'i18n.domain.parker-registration.ParkingSubscriptionType.' + ParkingSubscriptionType[subscription.type];
  }

}
